export const CGUTextComponent = () => {

    return (
        <div className="">
            <h1 className="text-xl text-gray-900 font-bold">Chooz - Conditions générales d’utilisations</h1>
            <p className="mt-2 text-sm text-gray-700">
                Cette application est publié par Sarrux, SARL au capital de 1 000 000 FCFA, Abidjan, Côte d’Ivoire.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 1: Introduction</h1>
            <p className="mt-2 text-sm text-gray-700">
                Les présentes conditions générales d'utilisation (ci-après les "CGU") ont pour objet de définir les conditions 
                dans lesquelles les utilisateurs (ci-après les "Utilisateurs") peuvent accéder et utiliser l'application Chooz (ci-après l'"Application").
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 2: Acceptation des CGU</h1>
            <p className="mt-2 text-sm text-gray-700">
                En accédant et en utilisant l'Application, les Utilisateurs acceptent sans réserve les présentes CGU.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 3: Accès à l'Application</h1>
            <p className="mt-2 text-sm text-gray-700">
                L'Application est accessible 24h/24, 7j/7, sous réserve des périodes de maintenance et des incidents techniques.
                Sarrux s’engage à mettre en œuvre les moyens nécessaires pour assurer la disponibilité de l’Application 
                dans des conditions optimales, mais ne peut en aucun cas garantir un fonctionnement ininterrompu de l’Application.
                Les équipements (ordinateur, téléphone mobile, logiciels, moyens de télécommunication, etc.) 
                permettant l’accès à l’Application sont à la charge de l’Utilisateur, de même que les frais de télécommunications induits par leur utilisation. 
                Sarrux se réserve le droit de supprimer, modifier, corriger et compléter à tout moment et sans préavis les fonctionnalités et services fournis sur 
                l’Application ainsi que de désactiver l’Application sans préavis ou de suspendre temporairement l’Application.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 4: Obligations des Utilisateurs</h1>
            <p className="mt-2 text-sm text-gray-700">
                Les Utilisateurs s'engagent à utiliser l'Application en conformité avec les lois et règlements en vigueur et à ne pas porter 
                atteinte aux droits de tiers.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 5: Disposition financière</h1>
            <h2 className="text-base text-gray-900 font-bold mt-2" id="about_chargebacks">Clauses chargesbacks</h2>
            <p className="mt-1 text-sm text-gray-700">
                Le client s’engage à utiliser que les cartes dont il est le réel détenteur. En cas d’utilisation de la carte d’autrui, 
                le client aura l’obligation de prouver en cas de chargeback (réclamation bancaire) le lien qu’il entretient avec 
                le propriétaire en communiquant un échange ou preuve montrant qu’il a l’autorisation de ce dernier pour effectuer la transaction.
                Toute transaction ou recharge effectuée par une carte qui n’appartient pas à l’initiateur devra être, si demandée, obligatoirement justifiée par ce dernier.
            </p>

            <h2 className="text-base text-gray-900 font-bold mt-2" id="about_cancels">Conditions d'annulation de service </h2>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Annulation par l'utilisateur: </strong>
                L'utilisateur peut demander l'annulation d'un vote dans un delai d'une heure après son vote.
                Aucun remboursement ne sera effectué pour les demandes d'annulation effectuées après le delai recommandé.
            </p>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Annulation par Chooz: </strong>
                Chooz se réserve le droit d'annuler une session de vote payante pour des raisons telles que des problèmes techniques,
                des activités frauduleuses ou toute autre circonstance imprévue. En cas d'annulation par Chooz, les utilisateurs seront intégralement remboursés.
            </p>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Modalités de remboursement: </strong>
                Les remboursements seront effectués selon le mode de paiement initial et dans un délai raisonnable après l'annulation de la session de vote.
            </p>

            <h2 className="text-base text-gray-900 font-bold mt-2" id="about_doubledebit">Conditions en cas de double facturation</h2>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Notification: </strong>
                En cas de double facturation, l'utilisateur doit immédiatement contacter le support client de Chooz pour signaler le problème.
            </p>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Vérification: </strong>
                Chooz examinera toutes les réclamations de double facturation et prendra les mesures nécessaires pour rectifier la situation dans les meilleurs délais.
            </p>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Remboursement: </strong>
                En cas de double facturation avérée, Chooz remboursera intégralement le montant excédentaire prélevé sur le compte de l'utilisateur.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 6: Responsabilité</h1>
            <p className="mt-2 text-sm text-gray-700">
                Chooz ne peut être tenu responsable en cas de mauvaise utilisation de l'Application par un Utilisateur.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 7: Modification des CGU</h1>
            <p className="mt-2 text-sm text-gray-700">
                Chooz se réserve le droit de modifier les présentes CGU à tout moment. Les Utilisateurs seront informés de ces modifications par tout moyen utile.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 8: Droit applicable et juridiction</h1>
            <p className="mt-2 text-sm text-gray-700">
                Les présentes CGU sont soumises au droit ivoirien. En cas de litige, les tribunaux ivoiriens seront seuls compétents.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 9: Protection des données personnelles</h1>
            <p className="mt-2 text-sm text-gray-700">
                En souscrivant à nos Services, vous reconnaissez et acceptez que nous traiterons votre nom et votre adresse e-mail pour communiquer avec vous 
                pour la présentation et la promotion de nos Services ou nouveaux services. Vous pouvez à tout moment, gratuitement, 
                vous désinscrire de cette communication électronique, en adressant un e-mail à chooz@sarrux.com.
                Toute personne ayant reçu votre autorisation d’accéder à ces données sont tenues par une obligation de confidentialité et s’exposent à des 
                mesures disciplinaires et/ou autres sanctions si elles ne respectent pas ces obligations.
                Conformément à cette politique, vous reconnaissez et acceptez que nous communiquons vos données ainsi que celles de vos Votant à nos employés; 
                dans la limite nécessaire à l’accomplissement des tâches qui leurs sont confiées. Ces personnes pourront être amenées à vous contacter 
                directement à partir des coordonnées que vous nous avez communiquées.
                Veuillez consulter notre <a href="https://www.sarrux.com/privacy" target="_blank">politique de confidentialité et de cookies</a> pour obtenir 
                des informations sur les données que nous collectons ; la finalité de chaque collecte ; la durée de conservation ainsi que la localisation.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 10: Propriété intellectuelle</h1>
            <p className="mt-2 text-sm text-gray-700">
                Vous conservez l'entière propriété des données que vous hébergez sur l’Application. Nous nous réservons le droit de les dupliquer à des fins 
                d’hébergement et de sauvegarde. Nous sommes et demeurons propriétaire exclusif de tous droits d'auteur, marques et autres droits de 
                propriété intellectuelle ainsi que tout autre droit de propriété portant sur l’Application, les interfaces et développements spécifiques, 
                les guides d'utilisation et la documentation y afférent.
                Nous garantissons que nous disposons de l'ensemble des droits nécessaires pour que vous puissiez avoir accès à l’Application, 
                sous réserve que vous l’utilisez conformément aux dispositions des présentes CGU.
                Tout autre exploitation de l'Application et des données y afférentes par l’Utilisateur, sans autorisation expresse et préalable de Sarrux, 
                est interdite et constituerait une contrefaçon sanctionnée par les articles ... et suivants du Code de la Propriété Intellectuelle.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5" id="about_service">Article 11: Conditions de fourniture de service</h1>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Disponibilité du service: </strong>
                Chooz s'engage à fournir ses services de manière continue et fiable, mais ne peut garantir une disponibilité à 100% 
                en raison de facteurs indépendants de sa volonté tels que les pannes de serveurs ou les problèmes de connexion Internet.
            </p>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Responsabilité de l'utilisateur: </strong>
                L'utilisateur est responsable de s'assurer que ses équipements informatiques et sa connexion 
                Internet sont adéquats pour utiliser les services de Chooz. 
                Chooz n'est pas responsable des interruptions de service causées par des problèmes liés aux équipements de l'utilisateur.
            </p>
            <p className="mt-1 text-sm text-gray-700">
                <strong>Support client: </strong>
                Chooz fournit un support client pour aider les utilisateurs en cas de problème technique ou de question concernant l'utilisation de la plateforme.
                Le support client est accessible via <a href="mailto:support.chooz@sarrux.com">support.chooz@sarrux.com</a>.
            </p>

            <h1 className="text-lg text-gray-900 font-bold mt-5">Article 12: Contact</h1>
            <p className="mt-2 text-sm text-gray-700">
                Pour toute question ou réclamation concernant l'Application, les Utilisateurs peuvent contacter Chooz par email à 
                l'adresse suivante: <a href="mailto:support.chooz@sarrux.com">support.chooz@sarrux.com</a>.
            </p>
        </div>
    );
};